import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../../data/bonuses';
import { CheckoutButton } from '../CheckoutButton';
export function BonusesSection() {
  return <section className="bg-navy-900 px-4 py-14 sm:py-20" data-id="element-107" data-mp="qcz727bm1c5c">
      <div className="mx-auto w-full max-w-5xl" data-id="element-108" data-mp="qek3k2hhj55u">
        <div className="text-center" data-id="element-109" data-mp="vbajmptai0r9">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-aqua-200" data-id="element-110" data-mp="vcc4tn40s3mp">
            🎁 Exclusive bonuses
          </p>
          <h2 className="mt-3 font-display text-[27px] font-bold leading-[1.14] tracking-tight text-white sm:text-4xl" data-id="element-111" data-mp="1o0hp68r5vqm0">
            Today, you'll also get these 5 bonuses free
          </h2>
          <p className="mt-3 inline-flex rounded-full bg-aqua-500/15 px-4 py-1.5 text-[12px] font-extrabold uppercase tracking-wide text-aqua-300 ring-1 ring-aqua-400/30" data-id="element-112" data-mp="199qwkyhqwnhu">
            A $133 value — included free
          </p>
        </div>

        <div className="mt-9 space-y-4 sm:space-y-5" data-id="element-113" data-mp="26s0tciwx9apm">
          {bonuses.map(bonus => <article key={bonus.tag} className="overflow-hidden rounded-2xl bg-white/6 ring-1 ring-white/12 sm:flex sm:items-center sm:gap-6 sm:p-5" data-id="element-114" data-mp="2m4phkb9s3253">
              <img src={bonus.image} alt={`${bonus.title} mockup`} loading="lazy" className="w-full rounded-t-2xl bg-white object-cover sm:w-2/5 sm:shrink-0 sm:rounded-xl" data-id="element-115" data-mp="2vvtr2vgopusj" />
              <div className="p-5 sm:flex-1 sm:p-0" data-id="element-116" data-mp="34y33jqvijy8k">
                <div className="flex flex-wrap items-center gap-2" data-id="element-117" data-mp="2zxot626fwc7d">
                  <span className="inline-flex items-center gap-1.5 rounded-md bg-aqua-500 px-2.5 py-1 text-[11px] font-extrabold uppercase tracking-wide text-white" data-id="element-118" data-mp="3eu626mr5peqr">
                    <GiftIcon className="h-3 w-3" aria-hidden="true" data-id="element-119" data-mp="39vusqd4rx692" />
                    {bonus.tag}
                  </span>
                  <span className="rounded-md bg-white/10 px-2.5 py-1 text-[11px] font-bold uppercase tracking-wide text-aqua-200" data-id="element-120" data-mp="1fh21eqaxb1mx">
                    Value: {bonus.value}
                  </span>
                </div>
                <h3 className="mt-3 font-display text-[22px] font-bold leading-tight text-white sm:text-2xl" data-id="element-121" data-mp="2969g64mzau2o">
                  {bonus.title}
                </h3>
                <p className="mt-2 text-[14.5px] leading-relaxed text-white/70" data-id="element-122" data-mp="2e7yvvxl5bvx3">{bonus.description}</p>
              </div>
            </article>)}
        </div>

        <div className="mt-9" data-id="element-123" data-mp="2o3abei4dp75w">
          <CheckoutButton label="I want the bonuses too" sub="All 5 bonuses included free with your purchase" data-id="element-124" data-mp="2o28z6abmmeml" />
        </div>
      </div>
    </section>;
}